// extracted by mini-css-extract-plugin
export default {"wrapper":"_3LDnD8SO","icon":"_2BXVpFb-","input":"HXumnk-t"};